/* Product Tile Markup - You can play around with this to change the
information that appears on the Wishlisted Product tiles  */
var productCardMarkup = `<div class="swym-wishlist-grid">
   {{#products}} 
   <a href="{{du}}"aria-label="{{dt}}" class="swym-wishlist-item swym-is-anchor stamped-product-reviews-badge">
     <button id="swym-remove-productBtn" aria-label="Delete" data-variant-id="{{epi}}" data-product-id="{{empi}}" class="swym-delete-btn swym-nav swym-nav-1 swym-is-button">
       <span class="swym-icon">
       </span>
     </button>
     <div class="swym-wishlist-image-wrapper">
       <img alt="" class="swym-wishlist-image" src="{{iu}}">
     </div>
     <button class="swym-is-button">
       <div class="swym-title swym-title-1">
         {{dt}}
       </div>
     </button>
     <div class="swym-variant-title swym-text swym-title-2 swym-variant-title-spacer">
       {{variantinfo}}
     </div>
     <div class="swym-product-price swym-text swym-text-1">
       <div class="swym-product-final-price swym-value">
         <span>$</span>{{pr}}
       </div>
     </div>
     {{#variantinfo}}
     <button  id="swym-custom-Select-options" type="button" class="swym-add-to-cart-btn swym-button swym-button-1" data-variant-id="{{epi}}" data-product-id="{{empi}}" data-action="open-modal" aria-controls="modal-quickadd" onclick="selectOptionsHandler.handleRequest('{{empi}}')">
      Select options
     </button>
     {{/variantinfo}}
     {{^variantinfo}}
      <button id="swym-custom-add-toCartBtn" data-state-cart="{{#isInCart}} swym-added{{/isInCart}}" data-product-url="{{du}}" data-variant-id="{{epi}}" data-product-id="{{empi}}" class="swym-add-to-cart-btn swym-button swym-button-1">
        {{#isInCart}}Added to cart{{/isInCart}}{{^isInCart}}Add to cart{{/isInCart}}
      </button>
     {{/variantinfo}}
   </a>
   {{/products}}
</div>`;

var headerWishlistpage = `<div class="swym-wishlist-detail-header">
{{#customer}} 
<h2 class="swym-wishlist-main-title">My Wishlist</h2>
<div class="swym-wishlist-wrap-login">
    <button onclick="{{^logged}}openDialog('dialog-login'){{/logged}}" id="btn__logged" class="swym-user-login-status swym-svg"> 
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M16.1249 6.75C15.9412 9.22828 14.0624 11.25 11.9999 11.25C9.93742 11.25 8.05538 9.22875 7.87492 6.75C7.68742 4.17188 9.51554 2.25 11.9999 2.25C14.4843 2.25 16.3124 4.21875 16.1249 6.75Z" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M12 14.25C7.92187 14.25 3.7828 16.5 3.01687 20.7469C2.92452 21.2588 3.21421 21.75 3.74999 21.75H20.25C20.7862 21.75 21.0759 21.2588 20.9836 20.7469C20.2172 16.5 16.0781 14.25 12 14.25Z" stroke="black" stroke-miterlimit="10"/>
      </svg>
      <span class="swym-user-text">{{#logged}}{{email}}{{/logged}}{{^logged}}Guest Shopper{{/logged}}</span>
    </button>
    <button class="swym-wishlist-options swym-svg" onclick="{{#logged}}openDialog('dialog-shareEmail'){{/logged}}{{^logged}}openDialog('dialog-login'){{/logged}}">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M13.0625 12C13.0625 12.5868 12.5868 13.0625 12 13.0625C11.4132 13.0625 10.9375 12.5868 10.9375 12C10.9375 11.4132 11.4132 10.9375 12 10.9375C12.5868 10.9375 13.0625 11.4132 13.0625 12Z" fill="black" stroke="black" stroke-width="0.125"/>
        <path d="M13.0625 6C13.0625 6.5868 12.5868 7.0625 12 7.0625C11.4132 7.0625 10.9375 6.5868 10.9375 6C10.9375 5.4132 11.4132 4.9375 12 4.9375C12.5868 4.9375 13.0625 5.4132 13.0625 6Z" fill="black" stroke="black" stroke-width="0.125"/>
        <path d="M12 19.125C12.6213 19.125 13.125 18.6213 13.125 18C13.125 17.3787 12.6213 16.875 12 16.875C11.3787 16.875 10.875 17.3787 10.875 18C10.875 18.6213 11.3787 19.125 12 19.125Z" fill="black"/>
      </svg>
      <span class="swym-user-text">Options</span>
    </button>
  {{/customer}}
  </div>

  <dialog class="dialog_login">
    <div class="swym-modal-content">
        <div class="swym-save-wishlist-modal-dialog"><button onclick="closeDialog('dialog-login')"
                class="swym-close-btn swym-icon swym-is-button swym-nav swym-nav-1" aria-label="Close Modal"></button>
            <div class="swym-save-summary">
                <h2 class="swym-text-heading swym-heading swym-heading-1">Save your list</h2>
                <div class="swym-text-content swym-text swym-text-1">You are currently shopping anonymously. Either log in or save your wishlist items by entering your email address.</div>
                    <a href="/account/login"><button
                    class="swym-login-btn swym-button swym-button-1">LOGIN TO SAVE</button></a>
            </div>
        </div>
    </div>
  </dialog>

  <dialog class="dialog_login dialog_shareEmail">
    <div class="swym-modal-content">
        <div class="swym-save-wishlist-modal-dialog"><button onclick="closeDialog('dialog-shareEmail')"
                class="swym-close-btn swym-icon swym-is-button swym-nav swym-nav-1" aria-label="Close Modal"></button>
                <div class="swym-share-wishlist-input-container">
                <div class="swym-clear-text">
                    <h2 class="swym-text-heading swym-heading swym-heading-1">Share List via Email</h2>
                    <div class="swym-input-container">
                      <input type="text" placeholder="Sender name"
                      id="swym-name" aria-invalid="true"
                      class="swym-share-wishlist-name swym-input swym-no-zoom-fix swym-input-1">
                    </div>
                    <div class="swym-input-container swym-has-required" id="swym-email">
                      <input type="text" aria-invalid="false"
                      placeholder="Recipients email"
                      class="swym-share-wishlist-email swym-input swym-no-zoom-fix swym-input-1">
                    </div>
                    <div class="swym-input-container">
                      <textarea placeholder="Message" id="swym-note"
                      aria-invalid="false"
                      class="swym-share-wishlist-note swym-input swym-no-zoom-fix swym-input-2"></textarea>
                    </div>
                    <div class="swym-share-email-button-container"><button onclick="sendListViaEmail()"
                            class="swym-share-wishlist-email-btn swym-button swym-button-1 swym-is-button swym-bg-2 swym-color-4 swym-disabled"
                            >Share wishlist</button></div>

                    <div class="or_share_via">
                      <div class="divider"></div>
                      <span class="text_or_share_via">Or share via</span>
                      <div class="divider"></div>
                    </div>

                    <div class="share_on_social_networks">
                      <button class="social coppy_Link" onclick="generateSharedListURL()">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M9.75 16.5H6.75C5.55653 16.5 4.41193 16.0259 3.56802 15.182C2.72411 14.3381 2.25 13.1935 2.25 12C2.25 10.8065 2.72411 9.66193 3.56802 8.81802C4.41193 7.97411 5.55653 7.5 6.75 7.5H9.75" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M14.25 7.5H17.25C18.4435 7.5 19.5881 7.97411 20.432 8.81802C21.2759 9.66193 21.75 10.8065 21.75 12C21.75 13.1935 21.2759 14.3381 20.432 15.182C19.5881 16.0259 18.4435 16.5 17.25 16.5H14.25" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M7.6543 12H16.4396" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                      <span class="text_social text_coppy_Link">Copy link</span>
                      </button>
                      <button class="social facebook" onclick="shareListSocialFacebook()">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path d="M16 0.892857C16 0.428571 15.5714 0 15.1071 0H0.857143C0.392857 0 0 0.428571 0 0.892857V15.1429C0 15.6071 0.392857 16 0.857143 16H8.53571V9.82143H6.42857V7.39286H8.53571V5.60714C8.53571 3.57143 9.78571 2.42857 11.6429 2.42857C12.5 2.42857 13.2857 2.5 13.5 2.53571V4.67857H12.2143C11.2143 4.67857 11.0357 5.17857 11.0357 5.85714V7.39286H13.4286L13.1071 9.82143H11.0357V16H15.1071C15.5714 16 16 15.6071 16 15.1429V0.892857Z" fill="black"/>
                      </svg>
                        <span class="text_social text_facebook">Facebook</span>
                      </button>
                      <button class="social twitter" onclick="shareListSocialTwitter()">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="16" viewBox="0 0 20 16" fill="none">
                          <path d="M17.9648 3.97108C18.7476 3.39277 19.4521 2.6988 20 1.88916C19.2955 2.19759 18.4736 2.42892 17.6517 2.50602C18.5127 2.00482 19.1389 1.23373 19.4521 0.26988C18.6693 0.73253 17.7691 1.07952 16.8689 1.27229C16.0861 0.462651 15.0294 0 13.8552 0C11.5851 0 9.7456 1.81205 9.7456 4.04819C9.7456 4.35663 9.78474 4.66506 9.86301 4.97349C6.45793 4.78072 3.40509 3.16145 1.36986 0.73253C1.01761 1.31084 0.821918 2.00482 0.821918 2.7759C0.821918 4.16386 1.52642 5.39759 2.66145 6.13012C1.99609 6.09157 1.33072 5.93735 0.782779 5.62892V5.66747C0.782779 7.63374 2.19178 9.25301 4.07045 9.63855C3.75734 9.71566 3.36595 9.79277 3.0137 9.79277C2.73973 9.79277 2.50489 9.75422 2.23092 9.71566C2.73973 11.3349 4.26614 12.4916 6.06654 12.5301C4.65753 13.6096 2.89628 14.2651 0.978474 14.2651C0.626223 14.2651 0.313112 14.2265 0 14.188C1.80039 15.3446 3.95303 16 6.30137 16C13.8552 16 17.9648 9.86988 17.9648 4.51084C17.9648 4.31807 17.9648 4.16386 17.9648 3.97108Z" fill="black"/>
                        </svg>
                        <span class="text_social text_twitter">Twitter</span>
                      </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </dialog>
</div>`;

var noProduct = `<div class="swym-wishlist-detail-content">
<div class="swym-empty-wishlist-container">
  <h3 class="swym-empty-wishlist-title swym-empty-text">Love It? Add to My Wishlist</h3>
  <p class="swym-empty-wishlist-text swym-empty-text">My Wishlist allows you to keep track of all of your favorites and shopping activity whether you're on your computer, phone, or tablet. 
You won't have to waste time searching all over again for that item you loved on your phone the other day - it's all here in one place!</p>
<a href="/collections/all"><button class="swym-empty-wishlist-continue-btn">Continue shopping</button></a></div></div>
`;

var errorMessage = `<span id="swym-error" class="show_error_message">this field is required!</span>`
var errorMessageValidateEmail = `<span id="swym-error" class="show_error_message">Invalid email address!</span>`

var dataInfoProduct = []

function openDialog(item) {
  if (item === "dialog-login") {
    const dialogLogin = document.querySelector(".dialog_login")
    dialogLogin.showModal()
  } else {
    const dialogShareEmail = document.querySelector(".dialog_shareEmail")
    dialogShareEmail.showModal()
  }
}

function closeDialog(item) {
  if (item === "dialog-login") {
    const dialogLogin = document.querySelector(".dialog_login")
    dialogLogin.close()
  } else {
    const dialogShareEmail = document.querySelector(".dialog_shareEmail")
    dialogShareEmail.close()
  }
}

function sendListViaEmail() {
  const valuename = document.querySelector(".swym-share-wishlist-name")
  const valueEmail = document.querySelector(".swym-share-wishlist-email")
  const valuenote = document.querySelector(".swym-share-wishlist-note")
  const swymEmail = document.getElementById("swym-email");
  const swymError = document.getElementById("swym-error");

  try {
    if (!$(valueEmail).val() && !swymError) {
      swymEmail.innerHTML += errorMessage;
    }
  
    if ($(valueEmail).val()) {
      window._swat.sendListViaEmail(
        {
         toEmailId: $(valueEmail).val(),
         fromName: $(valuename).val(),
         note: $(valuenote).val(),
         lid: null, // null when multiple list is not enabled
         cprops: {}, // custom props for the share, future usage
        },
        function(r) {
          closeDialog('dialog-shareEmail')
          swymError.remove();
        },
        function(r) {
          console.log('Email failed!');
        }
      );
    }
  } catch (error) {
    swymError?.remove();
    if (error) {
      swymEmail.innerHTML += errorMessageValidateEmail;
    }
  }
}

function generateSharedListURL() {
  window._swat.generateSharedListURL(
    null,
    function(data) { 
      navigator.clipboard.writeText(data);
    }
  );
}

function shareListSocialFacebook() {
  const valuename = document.querySelector(".swym-share-wishlist-name")
  window._swat.shareListSocial(
    null,
    $(valuename).val(),
    "https://www.facebook.com/sharer.php?u={{shareurl}}&t={{note}}",
    "facebook",
    "Hello",
    function(data) { console.log(data) }
  ); // will open facebook share dialog
}

function shareListSocialTwitter() {
  const valuename = document.querySelector(".swym-share-wishlist-name")
  window._swat.shareListSocial(
    null,
    $(valuename).val(),
    "https://twitter.com/sharer",
    "twitter",
    "Hello",
    function(data) { console.log(data) }
  ); // will open twitter share dialog
}

function getVariantInfo(variants) {
  try {
    let variantKeys =
        variants && variants != "[]"
          ? Object.keys(JSON.parse(variants)[0])
          : [],
      variantinfo;
    if (variantKeys.length > 0) {
      variantinfo = variantKeys[0];
      if (variantinfo == "Default Title") {
        variantinfo = "";
      }
    } else {
      variantinfo = "";
    }
    return variantinfo;
  } catch (err) {
    return variants;
  }
}

function onAddToCartClick(e) {
  e.preventDefault();
  var productId = e.currentTarget.getAttribute("data-product-id");
  var variantId = e.currentTarget.getAttribute("data-variant-id");
  var du = e.target.getAttribute("data-product-url");
  e.target.innerHTML = "Adding..";
  window._swat.replayAddToCart(
    {
      empi: productId,
      du: du,
    },
    variantId,
    function (c) {
      e.target.innerHTML = "Added to Cart";
      // e.target.setAttribute("data-state-cart", "swym-added");
      console.log("Successfully added product to cart.", c);
      document.dispatchEvent(new CustomEvent('product:added', {
        bubbles: true,
        detail: {
          variant: c
        }
      }))
    },
    function (e) {
      console.log(e);
    }
  );
}

function buildSwatch(data, indx) {
  var itemSwatchHtml = '';
  if (boostPFSThemeConfig.custom.show_color_swatch) {
  var color_name = boostPFSThemeConfig.custom.section_id + '-' + data.id + '-' + indx;
  data.options.forEach(function (option, index) {
    var option_name = option.name.toLowerCase();
    itemSwatchHtml += `<div class="swatch-title">
      <span class="js-swatch-title">${option_name}: </span>
      <span class="Modal__Swatch-Title js-swatch-title-selected"></span>
    </div>`

    if (option_name.indexOf('color') != -1 || option_name.indexOf('colour') != -1 || option_name.indexOf('couleur') != -1) {
    var values = '';
    itemSwatchHtml += '<div class="ProductItem__ColorSwatchList">';
    var i = 0;
    data.variants.forEach(function (variant) {
      var temp = variant.merged_options.filter(function (obj) {
        obj = obj.toLowerCase();
        if (obj.indexOf('color') != -1 || obj.indexOf('colour') != -1)
          return obj;
      });
      temp = temp[0].split(':');

      var value = temp[1].toLowerCase();
      if (values.indexOf(value) == -1) {
        values = values + ',' + value;
        values = values.split(',');
        var size = '200,400,600,700,800,900,1000,1200';
        var supported_sizes = imageSize(size, variant.image);
        // var color_image = Utils.optimizeImage(variant.image);
        var name_color = Utils.slugify(value) + '.png';
        var checked = (i == 0) ? 'checked=checked' : '';
        var imageInfo = null;
        var image_aspect_ratio = 1;
        imageInfo = data.images.find(function (imageOb) {
          if (imageOb.src == variant.image){
            image_aspect_ratio = imageOb.width / imageOb.height;
          return imageOb;
          } 
        });
        if (!imageInfo){
          if (data.images.length > 0){
            imageInfo = data.images[0];
          } else {
            imageInfo = {
            src: boostPFSConfig.general.no_image_url,
              id: variant.id,
              width: 480,
              height: 480
            }
          }
          
        }
        var dataImg = (imageInfo != null) ? '" data-image-url="' + imageInfo.src + '" data-image-widths="[' + supported_sizes + ']" data-image-aspect-ratio="1" data-image-id="' + imageInfo.id + '"' : '';
        var color_input_id = color_name + "-" + values.length;
        var variant_price = variant.price ? variant.price : 0;
        var variant_compare_at_price = variant.compare_at_price ? variant.compare_at_price : 0;
// 			var url_color = Utils.getFilePath(Utils.slugify(value), Globals.swatchExtension, Settings.getSettingValue('general.swatchImageVersion'));
        var url_color = boostPFSAppConfig.general.asset_url.replace('boost-pfs.js', name_color);
        itemSwatchHtml += '<div class="ProductItem__ColorSwatchItem">';
        itemSwatchHtml += '<input class="ColorSwatch__Radio" type="radio" ' + checked + ' name="' + color_name + '" id="' + color_input_id + `" data-variant-id="${variant.id}` + '" value="' + value + '" data-image-aspect-ratio="' + image_aspect_ratio + '" data-variant-price="' + variant_price + '" data-variant-compare-at-price="' + variant_compare_at_price + '" data-variant-url="' + Utils.buildProductItemUrl(data) + '?variant=' + variant.id + '#Image' +  imageInfo.id + '"' + dataImg + '  aria-hidden="true">';
        itemSwatchHtml += '<label class="ColorSwatch ColorSwatch--small" for="' + color_input_id + '" style="background-color: ' + value.replace(' ', '').toLowerCase() + '; background-image: url(' + url_color + ')" title="' + value + '" data-tooltip="' + value + '"></label>';
        itemSwatchHtml += '</div>';
        i++;
      }
    });
    itemSwatchHtml += '</div>';
    } else {
      var i = 0;
      itemSwatchHtml += '<div class="ProductItem__ColorSwatchList">'
      data.variants.forEach(function (variant) {
        var temp = variant.merged_options.filter(function (obj) {
          obj = obj.toLowerCase();
          if (obj.indexOf('size') != -1 || obj.indexOf('shade') != -1)
            return obj;
        });
        temp = temp[0]?.split(':');
        var value = temp && temp[1].toLowerCase();

        var checked = (i == 0) ? 'checked=checked' : '';
        var size_name = color_name
        var size_input_id = size_name + '-' + i
        var variant_price = variant.price ? variant.price : 0;
        var variant_compare_at_price = variant.compare_at_price ? variant.compare_at_price : 0;
        itemSwatchHtml += '<div class="ProductItem__ColorSwatchItem">'
        itemSwatchHtml += `<input class="ColorSwatch__Radio" type="radio" ${checked} id="${size_input_id}" name="${size_name}" data-variant-id="${variant.id}" value="${value}" data-variant-price="${variant_price}" data-variant-comapre-at-price="${variant_compare_at_price}" aria-hidden="true"/>`
        itemSwatchHtml += '<label class="ColorSwatch ColorSwatch--size" for="' + size_input_id + '" title="' + value + '" data-tooltip="' + value + '">' + value + '</label>';
        itemSwatchHtml += '</div>';
        i++;
      });
      itemSwatchHtml += '</div>';
    }
  });
  }
  return itemSwatchHtml;
}

function buildImage(data, images) {
  var htmlImg = '';
  if (!images) images = [];
  if (images.length == 0){
    images.push({
      src: boostPFSConfig.general.no_image_url,
      id: data.id,
      width: 480,
      height: 480
    });
  }
  if (images.length > 0) {
    htmlImg += '<a href="{{itemUrl}}" class="ProductItem__ImageWrapper ';
    var use_natural_size = false;
    var has_alternate_image = false;
    if (boostPFSThemeConfig.custom.product_image_size == 'natural' || boostPFSThemeConfig.custom.use_horizontal) {
      use_natural_size = true;
    }
    if (boostPFSThemeConfig.custom.product_show_secondary_image && images.length > 1 && !boostPFSThemeConfig.custom.use_horizontal) {
      has_alternate_image = true;
    }
    if (has_alternate_image) {
      htmlImg += 'ProductItem__ImageWrapper--withAlternateImage';
    }
    htmlImg += '">';
    
    var max_width = images[0].width;
    if (boostPFSThemeConfig.custom.use_horizontal) max_width = 125;
    var withCall = use_natural_size ? 'withFallback' : boostPFSThemeConfig.custom.product_image_size;
    htmlImg += '<div class="AspectRatio AspectRatio--' + withCall + '" style="max-width: ' + max_width + 'px;';
    var aspect_ratio = images[0].width / images[0].height;
    if (use_natural_size) {
      htmlImg += 'padding-bottom: ' + (100 / aspect_ratio) + '%;';
    }
    htmlImg += ' --aspect-ratio: ' + aspect_ratio + '">';
    
    if (has_alternate_image && images.length > 1) {
      var sizes = '200,300,400,600,800,900,1000,1200';
      var support_size = imageSize(sizes, images[1]);
      var thumbUrl = Utils.optimizeImage(images[1]['src'], '{width}x');
      htmlImg += '<img class="ProductItem__Image ProductItem__Image--alternate Image--lazyLoad Image--fadeIn" data-src="' + thumbUrl + '" data-widths="[' + support_size + ']" data-sizes="auto" alt="' + data.title + '" data-image-id="' + images[1].id + '">';
    }
    
    var sizes_main = '200,400,600,700,800,900,1000,1200';
    var support_size = imageSize(sizes_main, images[0]);
    var thumbUrl_main = images.length > 0 ? Utils.optimizeImage(images[0]['src'], '{width}x') : boostPFSConfig.general.no_image_url;
    htmlImg += '<img class="ProductItem__Image Image--lazyLoad Image--fadeIn" data-src="' + thumbUrl_main + '" data-widths="[' + support_size + ']" data-sizes="auto" alt="' + data.title + '" data-image-id="' + images[0].id + '">';
    htmlImg += '<span class="Image__Loader"></span>';
    htmlImg += '<noscript>';
    htmlImg += '<img class="ProductItem__Image ProductItem__Image--alternate" src="' + Utils.optimizeImage(images[0]['src'], '600x') + '" alt="' + data.title + '">';
    htmlImg += '<img class="ProductItem__Image" src="' + Utils.optimizeImage(images[0]['src'], '600x') + '" alt="' + data.title + '">';
    htmlImg += '</noscript>';
    htmlImg += '</div>';
    htmlImg += '</a>';
  }
  return htmlImg;
}

function imageSize(sizes, image) {
  if (image) {
    var desired_sizes = sizes.split(',');
    var supported_sizes = '';
    for (var k = 0; k < desired_sizes.length; k++) {
      var size = desired_sizes[k];
      var size_as_int = size * 1;
      if (image.width < size_as_int) { break; }
      supported_sizes = supported_sizes + size + ',';
    }
    
    if (supported_sizes == '') supported_sizes = image.width;
    
    if(!jQ.isNumeric(supported_sizes)) {
      supported_sizes = supported_sizes.split(',').join(',');
      supported_sizes = supported_sizes.substring(0,supported_sizes.lastIndexOf(','));
    }
    return supported_sizes;
  } else {
    return '';
  }
}

function onSelectOption() {
  $(".js-button-atc").on('click', function () {
    const $this = $(this)
    const variantId = $this.attr('data-variant-selected')
    const quantity = $this.attr('data-quantity')
    document.dispatchEvent(new CustomEvent('theme:loading:start'));

    fetch(window.routes.cartAddUrl + '.js', {
      body: JSON.stringify({
        form_type: 'product',
        id: variantId,
        quantity
      }),
      credentials: 'same-origin',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
      }
    }).then(function (res) {
      document.dispatchEvent(new CustomEvent('theme:loading:end'));
      return res.json()
    }).then((data) => {
      $('[data-action="close-modal"]').trigger('click')
      document.dispatchEvent(new CustomEvent('product:added', {
        bubbles: true,
        detail: {
          variant: data,
          quantity
        }
      }))
    })
  })

    $('.js-button-quickadd').click(function () {
      const productId = $(this).data('product-id')
      const productData = dataInfoProduct.filter(item => item.epi === Number(productId))[0].data
      var newProductData = productData.variants.map( function (p) {
          p.merged_options = [`${productData.options[0].name}:${p.option1}`]
          return p;
        })

      document.dispatchEvent(new CustomEvent('product:quickadd', {
        bubbles: true,
        detail: {
          product: productData,
          swatch: buildSwatch(productData),
          images: buildImage(productData, productData.media)
        }
      }))
    })
}

function onRemoveBtnClick(e) {
  e.preventDefault();
  var epi = +e.currentTarget.getAttribute("data-variant-id");
  var empi = +e.currentTarget.getAttribute("data-product-id");
  window._swat.fetch(function (products) {
    products.forEach(function (product) {
      if (epi && empi && product.epi == epi && product.empi == empi) {
        window._swat.removeFromWishList(product, function () {
          if (!window.SwymCallbacks) {
            window.SwymCallbacks = [];
          }
          window.SwymCallbacks.push(swymRenderWishlist);
        });
      }
    });
  });
}

function renderWishlistCounter(){
  var elements = document.querySelectorAll(".js-swym-wish-counter");
  for(var i = 0; i < elements.length; i++){
    window._swat.renderWishlistCount(elements[i], function(cnt, elem){
      if (cnt === 0) {
        elem.style.display = "none"
      } else {
        elem.style.display = "flex"
      }
    });
  }
}
if(!window._swat){
  if(!window.SwymCallbacks){
    window.SwymCallbacks = [];
  }
  window.SwymCallbacks.push(renderWishlistCounter);
} else{
  renderWishlistCounter();
}

function swymRenderWishlist(swat) {
  // Get wishlist items
  swat.fetch(function (products) {
    var wishlistContentsContainer = document.getElementById(
      "wishlist-items-container"
    );
    var formattedWishlistedProducts = products.map( function (p) {
      p = SwymUtils.formatProductPrice(p); // formats product price and adds currency to product Object
      p.isInCart =
        _swat.platform.isInDeviceCart(p.epi) ||
        p.et == _swat.EventTypes.addToCart;
      p.variantinfo = p.vi ? getVariantInfo(p.vi) : "";
      var handle = p.du.split('/').pop()
      fetch(`/products/${handle}.js`).then(function (res) {
				return res?.json()
			}).then((data) => {
        data.variants.map( function (item) {
          item.price = item.price / 100
        })
        p.data = data
			})

      return p;
    });

    dataInfoProduct = formattedWishlistedProducts

    var productCardsMarkup = SwymUtils.renderTemplateString(productCardMarkup, {
      products: formattedWishlistedProducts,
    });
    var customer = window.CUSTOMER_STATE ? window.CUSTOMER_STATE.customer : {}

    var dataHeaderWishlistpages = SwymUtils.renderTemplateString(headerWishlistpage, {
      customer: customer,
      products: formattedWishlistedProducts,
    });
    
    if (wishlistContentsContainer) {
      wishlistContentsContainer.innerHTML = ""
      wishlistContentsContainer.innerHTML += dataHeaderWishlistpages;

      wishlistContentsContainer.innerHTML += productCardsMarkup;
      if (products.length == 0) {
        wishlistContentsContainer.innerHTML += noProduct;
      }
      attachClickListeners();
    } else {
      console.log("Container not found, Wishlist Page element not found");
    }
  });
}

function attachClickListeners() {
  var addToCartButtons = document.querySelectorAll(
    "#swym-custom-add-toCartBtn"
  );
  var removeBtns = document.querySelectorAll("#swym-remove-productBtn");
  var addSelectOptions = document.querySelectorAll(
    "#swym-custom-Select-options"
  );
  //   Add to cart Btns
  for (var i = 0; i < addToCartButtons.length; i++) {
    addToCartButtons[i].addEventListener("click", onAddToCartClick, false);
  }

  //   Remove Buttons
  for (var k = 0; k < removeBtns.length; k++) {
    removeBtns[k].addEventListener("click", onRemoveBtnClick, false);
  }

  //   select Option
  for (var i = 0; i < addSelectOptions.length; i++) {
    addSelectOptions[i].addEventListener("click", onSelectOption(), false);
  }
  console.log("Events attached!");
}

if (!window.SwymCallbacks) {
  window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymRenderWishlist); /* Init Here */
